import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Slider from "react-slick";
import img1 from './../../images/banner/towerb.png';
import img2 from './../../images/banner/towera.png';
import views1 from './../../images/banner/views1.png';
import executive from './../../images/banner/executive.png';
import TowerC from './../../images/banner/TowerC.jpg';
import views2 from './../../images/banner/views2.png';

const latestBlog = [
	{ 
		image: img2,
		name: "Goldcrest Tower A",
		link: "/goldcrest-dream-tower-a"
	},
	{ 
		image: img1,
		name: "Goldcrest Tower B",
		link: "/goldcrest-dream-tower-b"
	},
	{ 
		image: views1,
		name: "Views 1",
		link: "/portfolio-1"
	},
	{ 
		image: executive,
		name: "Executive",
		link: "/portfolio-1"
	},
	{ 
		image: TowerC,
		name: "Goldcrest Dreams Tower C",
		link: "/goldcrest-dream-tower-c"
	},
	{ 
		image: views2,
		name: "Views 2",
		link: "/portfolio-1"
	},
]
function SampleNextArrow(props) {
  const { onClick } = props;
  return (
  	<div className="owl-nav">
		<div className="owl-next la la-angle-right"  onClick={onClick}/>
	</div>	
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
	<div className="owl-nav">
		<div className=" owl-prev la la-angle-left" onClick={onClick} style={{zIndex:1 }}/>
	</div>
  );
}

class Slider1 extends Component{
	render(){
		var settings = {		
			arrows: false,
			centerMode: true,
			centerPadding: "500px",
            slidesToShow: 1,
			speed: 3000,
			navSpeed: 3000,		
            infinite: true,
			autoplay: true,
			nextArrow: <SampleNextArrow />,
			prevArrow: <SamplePrevArrow />,
			responsive: [
				{
				  breakpoint: 1920,
				  settings: {
					slidesToShow: 1,
					centerPadding: "400px",
				  }
				},
				{
				  breakpoint: 1200,
				  settings: {
					slidesToShow: 1,
					centerPadding: "250px",
				  }
				},
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 1,
					centerPadding: "250px",
				  }
				},
				{
				  breakpoint: 768,
				  settings: {
					slidesToShow: 1,
					centerPadding: "200px",
				  }
				},
				{
				  breakpoint: 600,
				  settings: {
					slidesToShow: 1,
					centerPadding: "90px",
				  }
				}
			]
        };
		return(
			<>
				<style>{`
					.amenities-carousel .amenit-box .media {
						width: 100%;
						height: 400px;
						overflow: hidden;
					}
					.amenities-carousel .amenit-box .media img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						display: block;
					}
					@media (max-width: 768px) {
						.amenities-carousel .amenit-box .media {
							height: 200px;
						}
					}
				`}</style>
				<Slider className="amenities-carousel owl-carousel owl-btn-center-lr " {...settings}>
					{latestBlog.map((item, index) => (
						<div className="items" key={index}>
							<div className="amenit-box" >
								<div className="media">
									<img src={item.image} alt={item.name} />
								</div>
								<div className="info">
									<h5 className="title">
										<i className="ti-home"></i>
										<span><Link to={item.link}>{item.name}</Link></span>
									</h5>
								</div>
							</div>
						</div>
					))}	
				</Slider>
			</>
		)
		
	}
	
}

export default Slider1;
						
						